<template>
  <label :for="id" class="collapse-title">
    <slot />
  </label>
</template>

<script lang="ts" setup>
const id = inject<string>('collapse-id')
</script>
